var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hideInApp || !_vm.isAppLogin)?_c('div',{staticClass:"nav-bar"},[_c('van-nav-bar',{attrs:{"border":_vm.border,"title":_vm.title},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('van-icon',{attrs:{"name":"cross"},on:{"click":_vm.goBack}})]},proxy:true}],null,false,2750361311)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }